import { CircularProgress, Stack, Typography } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";

export const PendingParameterChecks = () => {
  const { t } = useTenantTranslation();
  return (
    <Stack direction="row" gap={1} alignItems="center" role="status">
      <CircularProgress size={16} color="inherit" />
      <Typography variant="caption">
        {t("checkingParameterCompatibility")}
      </Typography>
    </Stack>
  );
};
